import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const FlexBox = styled(Box)({
  display: "flex",
});
